// extracted by mini-css-extract-plugin
module.exports = {"phoneBookList":"contactlist_phoneBookList__dmz_l","contact":"contactlist_contact__PDng8"};